import React from "react";
import Uppsala from "./locations/Uppsala";
import Stockholm from "./locations/Stockholm";
import Malmö from "./locations/Malmö";
import Göteborg from "./locations/Göteborg";

const DisplayMunicipalityText = ({ selectedMunicipality }) => {
  if (selectedMunicipality.length !== 1) {
    return <h2>Lediga lokaler i utvalda städer</h2>;
  }

  switch (selectedMunicipality[0]) {
    case "stockholm":
      return <Stockholm />;
    case "malmö":
      return <Malmö />;
    case "göteborg":
      return <Göteborg />;
    case "uppsala":
      return <Uppsala />;
    default:
      return null;
  }
};

export default DisplayMunicipalityText;
